import api from "api/config";

export const GetHousekeepingNotificationsAPI = async ({
  page = 1,
  pageSize = 20,
  unreadOnly = false,
}) => {
  const params = new URLSearchParams({
    page,
    pageSize,
    unreadOnly,
  });

  const response = await api({
    method: "GET",
    url: `/api/v1/housekeeping/notifications?${params}`,
  });

  return response;
};

export const MarkHousekeepingNotificationsReadAPI = async (ids) => {
  const response = await api({
    method: "POST",
    url: "/api/v1/housekeeping/notifications/read",
    data: ids?.length
      ? {
          ids,
          markAll: false,
        }
      : {
          markAll: true,
        },
  });

  return response;
};

export const AuthorizePusherChannelAPI = async ({ socket_id, channel_name }) => {
  const response = await api({
    method: "POST",
    url: "/api/v1/pusher/auth",
    data: {
      socket_id,
      channel_name,
    },
  });

  return response;
};
